export default [
  {
    path: 'productos',
    name: 'sucursalProductos',
    component: () => import('@/views/empresa/sucursales/productos/SucursalProductosHome.vue'),
    meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true },
    redirect: { name: 'empresa.sucursal.productos' }, // 👈 redirección

    children: [

      {
        path: '',
        name: 'empresa.sucursal.productos',
        component: () => import('@/views/empresa/sucursales/productos/SucursalProductosList.vue'),

      },
      {
        path: 'inventario',
        component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioHome.vue'),
        redirect: { name: 'empresa.sucursal.productos.inventario' }, // redirección al listado
        children: [
          {
            path: '',
            name: 'empresa.sucursal.productos.inventario',
            component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventario.vue'),
          },



        ],
      },



    ]
  },
  {
    path: 'productos/movimiento',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioHome.vue'),
    children: [



      {
        path: ':inventarioUuid', // inventario iniciado con UUID
        name: 'empresa.sucursal.productos.inventario.iniciado',
        component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioIniciado.vue'),
        props: true,
      },
      {
        path: ':inventarioUuid/finalizar', // inventario iniciado con UUID
        name: 'empresa.sucursal.productos.inventario.finalizar',
        component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioFinalizar.vue'),
        props: true,
      },
      {
        path: ':inventarioUuid/categoria/:categoriaId', // productos de una categoría
        name: 'empresa.sucursal.productos.inventario.categoria',
        component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioCategoria.vue'),
        props: true,
      },
    ],
  },




  {
    path: 'inventarios',
    name: 'empresa.sucursal.inventarios',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalInventarios.vue'),
    redirect: { name: 'empresa.sucursal.inventarios.list' }, // redirección al listado
    children: [
      {
        path: '', name: 'empresa.sucursal.inventarios.list', component: () => import('@/views/empresa/sucursales/productos/inventario/components/SucursalInventarioList.vue')
      },


    ],
  },
  {
    path: 'inventarios/nuevo',
    name: 'empresa.sucursal.productos.inventario.nuevo',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioNuevo.vue'),

  },
  {
    path: 'inventarios/resumen/:inventarioUuid', // inventario cerrado con UUID
    name: 'empresa.sucursal.productos.inventario.resumen',
    component: () => import('@/views/empresa/sucursales/productos/inventario/SucursalProductosInventarioResumen.vue'),
    props: true,
  },


]